// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__9dRdZ","h1":"style_h1__Z5oHe","subTitle":"style_subTitle__1rVKO"};